// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"175":"882195ca","497":"e6b02a09","818":"8a9ca82c"}[chunkId] + ".chunk.css";
};